import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class AsnOrders_ds_find_serialnumbersService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { id?: number, archived?: boolean, chainHead?: number, licensePlateId?: number, lotId?: number, lookupCode?: string, packagingId?: number, statusId?: number, outboundShipmentId?: number }): 
  Promise<{ result: { Id?: number, Archived?: boolean, ChainHead?: number, LicensePlateId?: number, LookupCode?: string, LotId?: number, OutboundShipmentId?: number, PackagingId?: number, StatusId?: number }[] }> 
  {
    let url = `${environment.backendUrl}api/AsnOrders/datasources/ds_find_serialnumbers/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { id?: number, archived?: boolean, chainHead?: number, licensePlateId?: number, lotId?: number, lookupCode?: string, packagingId?: number, statusId?: number, outboundShipmentId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Archived?: boolean, ChainHead?: number, LicensePlateId?: number, LookupCode?: string, LotId?: number, OutboundShipmentId?: number, PackagingId?: number, StatusId?: number }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/AsnOrders/datasources/ds_find_serialnumbers/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { id?: number, archived?: boolean, chainHead?: number, licensePlateId?: number, lotId?: number, lookupCode?: string, packagingId?: number, statusId?: number, outboundShipmentId?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, Archived?: boolean, ChainHead?: number, LicensePlateId?: number, LookupCode?: string, LotId?: number, OutboundShipmentId?: number, PackagingId?: number, StatusId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/AsnOrders/datasources/ds_find_serialnumbers/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
